/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { cls } from "cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { BreakdownOptions } from "./ProductDetailPageResult";
import { selectedTileButtonBorderStyling, baseHoverStyling } from "./VirtualGrouping/VirtualGroupingTiles.styles";
import QuantityPlusBadge from "./Shared/QuantityPlusBadge";
interface Props {
  itemNumber: string;
  breakdownOptions: BreakdownOptions[];
}
const ProductBreakdowns = ({
  itemNumber,
  breakdownOptions
}: Props) => {
  const lowerCaseItemNumber = itemNumber.toLowerCase();
  const isAnyItemInGroupPlusEligible = breakdownOptions?.some(option => option.isWebstaurantPlusEligible) ?? false;
  return <>
      {breakdownOptions?.length > 1 && <div>
          <h2 id="available-quantities" className="mb-1 text-sm">
            Available Quantities:
          </h2>
          <ul aria-labelledby="available-quantities" data-testid="available-quantities" className="grid grid-flow-row grid-cols-3 gap-2 list-none m-0">
            {breakdownOptions.map(({
          price,
          link,
          quantityPerPackaging,
          unitOfMeasurement,
          isWebstaurantPlusEligible,
          itemNumber: breakdownItemNumber
        }) => <li key={`li-${quantityPerPackaging}`}>
                  <a key={breakdownItemNumber} href={`${lowerCaseItemNumber === breakdownItemNumber ? "#" : link}`} aria-current={lowerCaseItemNumber === breakdownItemNumber && "page"} data-testid={isWebstaurantPlusEligible ? "webplus-quantity-flag" : "plus-ineligible-quantity"} className={cls("text-sm", "flex", "flex-col", "justify-center", "text-center", "relative before:content-['']", "before:absolute", "before:inset-0", "before:border-solid", "before:rounded", "rounded", "focus-visible:before:border-[3px]", "focus-visible:before:border-[#005FCC]", isAnyItemInGroupPlusEligible ? "py-[19px] px-2 before:z-5 h-full box-border" : "p-3", baseHoverStyling, lowerCaseItemNumber === breakdownItemNumber ? selectedTileButtonBorderStyling : "before:border before:border-gray-600")}>
                    <span aria-label={`${Number(quantityPerPackaging).toLocaleString()} per ${unitOfMeasurement}`} className={cls("text-base", "text-gray-800", "block", "leading-none", "font-bold")}>
                      {quantityPerPackaging > 1 && `${Number(quantityPerPackaging).toLocaleString()}/`}
                      <wbr />
                      {unitOfMeasurement}
                    </span>
                    <span className={cls("text-sm", "text-red-500", "block", "leading-none", "font-semibold")}>
                      <b>{formatAsCurrency.formatIfUndefined(price)}</b>
                    </span>
                    {isWebstaurantPlusEligible && <QuantityPlusBadge />}
                  </a>
                </li>)}
          </ul>
        </div>}
    </>;
};
export default ProductBreakdowns;